<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="900"
    scrollable
  >
    <v-card
      tile
      min-height="110"
    >
      <v-card-title
        class="primary font-weight-medium grey--text pt-1 pb-2 px-3"
      >
        Nuevo Usuario | Gestor
      </v-card-title>
      <v-card-subtitle class="primary pb-2 px-3">
        Complete los siguientes datos
      </v-card-subtitle>
      <v-card-text class="px-0">
        <pre></pre>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <input-component
                    v-model="user.first_name"
                    :v="{}"
                    :errors="[]"
                    :label="'Nombre'"
                  />
                </v-col>
                <v-col cols="12">
                  <input-component
                    v-model="user.last_name"
                    :v="{}"
                    :errors="[]"
                    :label="'Apellidos'"
                  />
                </v-col>
                <v-col cols="12">
                  <input-component
                    v-model="user.username"
                    :v="{}"
                    :errors="[]"
                    :label="'Usuario'"
                  />
                </v-col>
                <v-col cols="12">
                  <input-component
                    v-model="user.email"
                    :v="{}"
                    :errors="[]"
                    :label="'Correo electrónico'"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-select
                    v-model="user.areas"
                    :items="areas"
                    item-text="name"
                    item-value="id"
                    chips
                    label="Proyectos (Deben asignarse al usuario)"
                    multiple
                    outlined
                    hide-details="true"
                  ></v-select>
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-select
                    v-model="user.groups"
                    :items="groups"
                    item-text="name"
                    item-value="id"
                    chips
                    label="Roles (Asignarse al usuario)"
                    multiple
                    outlined
                    hide-details="true"
                  ></v-select>
                </v-col>

              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="grey"
          @click="closeDialog"
        >
          Cancelar
        </v-btn>
        <v-btn
          depressed
          color="success"
          @click="createUser"
          :loading="sending"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import types from '@/types';
import { bus } from '@/main';
import InputComponent from '@/components/forms/InputComponent';
import { required } from 'vuelidate/lib/validators';

export default {
  props: [
    'value',
  ],

  components: {
    InputComponent,
  },

  data() {
    return {
      sending: false,
      user: this.newUser(),
      values: [''],
    };
  },

  validations: {
    user: {
      first_name: {
        required,
      },
    },
  },

  watch: {
    dialog(value) {
      if (value) {
        this.newUser();
      }
    },
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ...mapState(
      `${types.USER}`, [
        'areas',
        'groups',
        'applications',
      ],
    ),
  },

  methods: {
    ...mapMutations(
      `${types.APP}`, [
        types.SHOW_BUSY,
        types.HIDE_BUSY,
        types.SHOW_SUCCESS,
        types.SHOW_ERROR,
      ],
    ),
    ...mapActions({
      [types.CREATE_USER]: `${types.USER}/${types.CREATE_USER}`,
      [types.SETUP_CREATE_USER]: `${types.USER}/${types.SETUP_CREATE_USER}`,
    }),
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.user = this.newUser();
        this.$v.$reset();
      }, 500);
    },
    newUser() {
      return {
        first_name: '',
        last_name: '',
        username: '',
        password: '12345678',
        email: '',
        areas: [],
        groups: [],
        applications: this.applications,
      };
    },
    createUser() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.sending = true;
      this[types.CREATE_USER](this.user)
        .then(() => {
          this[types.SHOW_SUCCESS]('Usuario creado.');
          bus.$emit('refreshUserList');
          this.closeDialog();
        })
        .catch(() => {
          this[types.SHOW_ERROR]('Hubo un error creando un usuario');
        })
        .finally(() => {
          this.sending = false;
        });
    },

  },

  mounted() {
    this[types.SETUP_CREATE_USER]();
    this.user = this.newUser();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UserCreateComponent.vue